import { render } from "./SolicitudComponent.vue?vue&type=template&id=22e10dd0"
import script from "./SolicitudComponent.vue?vue&type=script&lang=js"
export * from "./SolicitudComponent.vue?vue&type=script&lang=js"

import "./SolicitudComponent.vue?vue&type=style&index=0&id=22e10dd0&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__